import React from "react"
import { Router, Route, Switch, Redirect } from "react-router-dom"
// import { Router, Route, Switch, Redirect } from "react-router-dom"
import Home from "./pages/Home"
import {
  Register,
  QRRegister,
  Login,
  PasswordRecovery,
  ResetPassword
} from "./pages/auth"

import {
  LoanSimulator,
  PaymentLoading,
} from "./pages/bill"

import Container from "./layout/Container"

import history from "./HistoryExport"

import {
  OneAction,
  FormAction,
} from "./pages/crm"

import {
  PublicDetail,
  DeliveryDetail,
} from "./pages/last-mile"

const Routes = (mainProps) => {
  return (
    <Router history={history}>
      <Container>
        <Switch>
          <Route exact path="/" component={Home} />
          {/* <Route exact path="/home" component={Home} /> */}
          {/* <Route exact path="/simulator" render={(props) => React.createElement(LoanSimulator, { ...props, ...mainProps })} /> */}
          {/* <Route exact path="/register" render={(props) => React.createElement(Register, { ...props, ...mainProps })} /> */}
          {/* <Route exact path="/qrregister" component={QRRegister} /> */}
          <Route exact path="/login" render={(props) => React.createElement(Login, { ...props, ...mainProps })} />
          {/* <Route exact path="/forgot-password" render={(props) => React.createElement(PasswordRecovery, { ...props, ...mainProps })} />
          <Route exact path="/reset" render={(props) => React.createElement(ResetPassword, { ...props, ...mainProps })} /> */}
          {/* <Route exact path="/oneaction" render={(props) => React.createElement(OneAction, { ...props, ...mainProps })} />
          <Route exact path="/formaction" render={(props) => React.createElement(FormAction, { ...props, ...mainProps })} />
          <Route exact path="/lastmile/clientSearch" render={(props) => React.createElement(PublicDetail, { ...props, ...mainProps })} />
          <Route exact path="/lastmile/publicDetail" render={(props) => React.createElement(DeliveryDetail, { ...props, ...mainProps })} />
          <Route exact path="/withdrawmethod" component={PaymentLoading} /> */}
          <Redirect to="/" />
        </Switch>
      </Container>
    </Router>
  )
}

export default Routes;